import { BigNumber } from "ethers"
import { PoolTokenType } from "impermax-sdk"
import useGenericCall from "./useGenericCall"
import { useOnchainPoolToken } from "./useOnchain"

export function useToBigNumber(amount: number, poolTokenTypeArg?: PoolTokenType) : BigNumber {
  return useGenericCall(useOnchainPoolToken(poolTokenTypeArg), poolToken => poolToken.toBigNumber(amount), [amount])
}

export function useToNumber(amount: BigNumber, poolTokenTypeArg?: PoolTokenType) : number {
  return useGenericCall(useOnchainPoolToken(poolTokenTypeArg), poolToken => poolToken.toNumber(amount), [amount])
}

export function useToTokens(amount: number, poolTokenTypeArg?: PoolTokenType) : BigNumber {
  return useGenericCall(useOnchainPoolToken(poolTokenTypeArg), poolToken => poolToken.toTokens(amount), [amount])
}

export function usefromTokens(amount: BigNumber, poolTokenTypeArg?: PoolTokenType) : number {
  return useGenericCall(useOnchainPoolToken(poolTokenTypeArg), poolToken => poolToken.fromTokens(amount), [amount])
}